import { render, staticRenderFns } from "./points_mall.vue?vue&type=template&id=1360847c&scoped=true"
import script from "./points_mall.vue?vue&type=script&lang=js"
export * from "./points_mall.vue?vue&type=script&lang=js"
import style0 from "./points_mall.vue?vue&type=style&index=0&id=1360847c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360847c",
  null
  
)

export default component.exports